import store from "../../store";
import useProduct from "./useProduct";
import { computed } from "vue";
import { optional } from "../../../helpers";

export default function usePhoto() {
  const { updateProductAttributeValue } = useProduct();
  const uploaderNamespace = "photoUploader/";
  const cropperNamespace = "photoCropper/";

  // computed
  const layout = computed(() => getComputedLayout());

  const layoutPhotoCount = computed(() => getComputedLayoutPhotoCount());

  const cropperConfig = computed(() => getComputedCropperConfig());

  function getComputedLayout() {
    const product = store.getters["product/getProduct"];

    return optional(product.attribute_values.photoLayout);
  }

  function getComputedLayoutPhotoCount() {
    const layout = getComputedLayout();
    const count = layout ? optional(layout.preferences).photoCount : 1;

    return Number(count);
  }

  function getComputedCropperConfig() {
    const layout = getComputedLayout();
    const aspectRatio = layout
      ? Number(optional(layout.preferences).aspectRatio)
      : 1 / 1;

    return {
      aspectRatio,
    };
  }

  function getImageUrl(index) {
    const originalImages = store.getters[`photoUploader/getFiles`][index];
    const cropperImages = store.getters[`photoCropper/getFiles`][index];

    if (cropperImages) {
      return cropperImages;
    } else if (originalImages) {
      return originalImages;
    }

    return null;
  }

  // [CUSTOM]
  function updatedPhotoLayout(index) {
    const type =
      store.getters["product/getAttributes"]["photoLayout"].attribute_values[
        index
      ];
    let product = store.getters["product/getProduct"];

    updateProductAttributeValue("photoLayout", type);
    // for editing - preset index
    type.index = index;
    product.attribute_values["photoLayout"] = type;

    store.commit("product/SET_PRODUCT", product);
  }

  function setIsSubmitted(index, value) {
    store.commit(`${uploaderNamespace}SET_SUBMITTED`, {
      index,
      value,
    });
  }

  return {
    // vars
    uploaderNamespace,
    cropperNamespace,
    // methods
    setIsSubmitted,
    updatedPhotoLayout,
    getImageUrl,
    // computed
    layout,
    layoutPhotoCount,
    cropperConfig,
  };
}
